<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ErrorPage from '@/pages/ErrorPage.vue';

const store = useStore();
const permissionError = computed(() => store.state.error.permissionError);
const errorCode = computed(() => store.state.error.errorCode);
const errorMessage = computed(() => store.state.error.errorMessage);
</script>


<template>
<!--    <ErrorPage-->
<!--        v-if="permissionError"-->
<!--        :errorCode="errorCode"-->
<!--        :errorMessage="errorMessage"-->
<!--    />-->
  <RouterView />
</template>
